<template>
  <div class="container">
    <LineChartGenerator
      v-if="loaded"
      :chart-options="chartOptions"
      :chart-data="chartData"
    />
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import { getRelativePosition } from "chart.js/helpers";
import moment from "moment";
import crud from "../../apis/crud";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  components: {
    LineChartGenerator,
  },
  data() {
    return {
      loaded: false,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: "#f87979",
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          filler: {
            propagate: false,
          },
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "REPAYMENT (7 Days)",
          },
        },
        onClick: (e) => {
          const { chart } = e;
          const canvasPosition = getRelativePosition(e, chart);
          // Substitute the appropriate scale IDs
          const dataX = chart.scales.x.getValueForPixel(canvasPosition.x);
          const dataY = chart.scales.y.getValueForPixel(canvasPosition.y);
          
          const periode = this.labels();
          const route = this.$router.resolve({
            name: "transaction.repayment",
            query: {
              tgl1: moment(periode[dataX]).format("YYYY-MM-DD"),
              tgl2: moment(periode[dataX]).format("YYYY-MM-DD"),
            },
          });
          window.open(route.href, "_blank");
        },
      },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "repayment_date",
        sortDesc: false,
        tablename: "repaymentsummary",
        tgl1: moment().add(-7, "d").format("YYYY-MM-DD"),
        tgl2: moment().format("YYYY-MM-DD"),
      },
    };
  },
  async mounted() {
    this.loaded = false;

    try {
      const periode = this.labels();
      const labels_ = [];

      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      if (this.tblData.tgl1 || this.tblData.tgl2) {
        if ((this.tblData.tgl2 || "") == "") {
          this.tblData.tgl2 = this.tblData.tgl1;
        }
        this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
        this.tblData.customQuery = `repayment_date = between '${this.tblData.tgl1}' and '${this.tblData.tgl2}'`;
      }
      crud.list(this.tblData).then((list) => {
        const data = periode.reduce((arr = [], dt, idx) => {
          const findDt = list.find(
            (x) => moment(x.repayment_date).format("YYYY-MM-DD") == dt
          );
          let obj = { x: moment(dt).format("DD MMM"), y: 0 };
          labels_.push(moment(dt).format("DD MMM"));
          if (findDt) {
            obj.y = findDt.total_repayment_sum;
          }
          arr.push(obj);
          return arr;
        }, []);
        setTimeout(() => {
          this.chartData.labels = labels_;
          this.chartData.datasets[0] = {
            label: "Repayment",
            borderColor: "#f87979",
            backgroundColor: "#f87979",
            data,
            fill: false,
          };
        }, 1000);
      });

      this.loaded = true;
    } catch (e) {
      this.loaded = true;
      console.error(e);
    }
  },
  created() {
    try {
    } catch (error) {
      console.log("error", error);
    }
  },
  methods: {
    labels() {
      let periode = [];
      let start = moment().add(-7, "d").format("YYYY-MM-DD");
      let max = 7;
      for (let index = 0; index < max; index++) {
        periode.push(
          moment(start)
            .add(index + 1, "d")
            .format("YYYY-MM-DD")
        );
      }
      return periode;
    },
  },
};
</script>
